namespace RioERP.Reports {
    export interface InvoiceBillingItemsReportRow {
        Id?: number;
        InvoiceDate?: string;
        OrderDate?: string;
        Invoicenumber?: string;
        EPaymentType?: number;
        CustomerName?: string;
        EInvoiceTo?: number;
        FranchiseeName?: string;
        City?: string;
        ProductName?: string;
        BillingItemName?: string;
        OrderNumber?: string;
        FranchiseeDiscountAmount?: number;
        OrderDiscount?: number;
        ProductDiscount?: number;
        HsnName?: string;
        TaxCategoryName?: string;
        Rate?: number;
        Quantity?: number;
        InvoiceCompanyId?: number;
        Total?: number;
        DiscountAmount?: number;
        NetAmount?: number;
        TaxableAmount?: number;
        CgstRate?: number;
        CgstAmount?: number;
        SgstRate?: number;
        SgstAmount?: number;
        IgstRate?: number;
        IgstAmount?: number;
        TotalTax?: number;
        EPaymentStatus?: number;
        InvoiceId?: number;
        OrderProductBillingItemId?: number;
        ProductBillingItemId?: number;
        FranchiseeId?: number;
        CustomerId?: number;
        ProductId?: number;
    }

    export namespace InvoiceBillingItemsReportRow {
        export const idProperty = 'Id';
        export const nameProperty = 'Invoicenumber';
        export const localTextPrefix = 'Reports.InvoiceBillingItemsReport';
        export const deletePermission = 'Reports:ReportsManagement:Modify';
        export const insertPermission = 'Reports:ReportsManagement:Modify';
        export const readPermission = 'Reports:ReportsManagement:View';
        export const updatePermission = 'Reports:ReportsManagement:Modify';

        export declare const enum Fields {
            Id = "Id",
            InvoiceDate = "InvoiceDate",
            OrderDate = "OrderDate",
            Invoicenumber = "Invoicenumber",
            EPaymentType = "EPaymentType",
            CustomerName = "CustomerName",
            EInvoiceTo = "EInvoiceTo",
            FranchiseeName = "FranchiseeName",
            City = "City",
            ProductName = "ProductName",
            BillingItemName = "BillingItemName",
            OrderNumber = "OrderNumber",
            FranchiseeDiscountAmount = "FranchiseeDiscountAmount",
            OrderDiscount = "OrderDiscount",
            ProductDiscount = "ProductDiscount",
            HsnName = "HsnName",
            TaxCategoryName = "TaxCategoryName",
            Rate = "Rate",
            Quantity = "Quantity",
            InvoiceCompanyId = "InvoiceCompanyId",
            Total = "Total",
            DiscountAmount = "DiscountAmount",
            NetAmount = "NetAmount",
            TaxableAmount = "TaxableAmount",
            CgstRate = "CgstRate",
            CgstAmount = "CgstAmount",
            SgstRate = "SgstRate",
            SgstAmount = "SgstAmount",
            IgstRate = "IgstRate",
            IgstAmount = "IgstAmount",
            TotalTax = "TotalTax",
            EPaymentStatus = "EPaymentStatus",
            InvoiceId = "InvoiceId",
            OrderProductBillingItemId = "OrderProductBillingItemId",
            ProductBillingItemId = "ProductBillingItemId",
            FranchiseeId = "FranchiseeId",
            CustomerId = "CustomerId",
            ProductId = "ProductId"
        }
    }
}
